import { useEffect, useRef } from "react";
import Swal from "sweetalert2";
//import dollar from "../../assets/images/dollar.svg";
//import friends from "../../assets/images/friends.svg";
import useAuthStore from "../../store/auth";

const MenuItem = ({
    closeMenu = () => {},
    svg = (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M20.2188 13.75C19.25 12.9375 18.0625 13.25 17.4688 13.7188L15.5938 15.125H15.4688C15.4688 13.9375 14.5312 13 13.3125 13H8.8125C7.9375 13 7.0625 13.3125 6.375 13.8438L5.46875 14.5H3.5C3.21875 14.5 3 14.75 3 15V15.5C3 15.7812 3.21875 16 3.5 16H6L7.28125 15.0312C7.71875 14.6875 8.25 14.5 8.8125 14.5H13.3125C14.1875 14.5 14.2188 15.7812 13.2812 15.7812H11.4062C11.1875 15.7812 11 15.9688 11 16.1875V16.2188C11 16.4375 11.1875 16.625 11.4062 16.625H15.625C15.9375 16.625 16.2188 16.5312 16.4688 16.3438L18.375 14.9062C18.625 14.7188 19.0312 14.7188 19.25 14.9062C19.5938 15.1875 19.5625 15.625 19.25 15.875L16.0938 18.2188C15.8438 18.4062 15.5625 18.5 15.25 18.5H3.5C3.21875 18.5 3 18.75 3 19V19.5C3 19.7812 3.21875 20 3.5 20H15.25C15.875 20 16.5 19.8125 17 19.4375L20.125 17.0625C20.6562 16.6875 20.9688 16.0938 20.9688 15.4375C21 14.8125 20.7188 14.1875 20.2188 13.75ZM11.0312 8.53125L12.5938 8.96875C12.7188 9 12.7812 9.09375 12.7812 9.21875C12.7812 9.375 12.6875 9.5 12.5312 9.5H11.5C11.4062 9.5 11.2812 9.46875 11.1875 9.40625C11.0312 9.34375 10.8438 9.375 10.75 9.46875L10.1875 10.0312C10.0312 10.1875 10.0625 10.4688 10.25 10.5938C10.5312 10.8125 10.875 10.9062 11.25 10.9688V11.5C11.25 11.7812 11.4688 12 11.75 12H12.25C12.5 12 12.75 11.7812 12.75 11.5V10.9688C13.6875 10.8438 14.4062 10 14.2812 9C14.1875 8.28125 13.625 7.71875 12.9375 7.5L11.375 7.0625C11.25 7.03125 11.1875 6.90625 11.1875 6.8125C11.1875 6.65625 11.3125 6.53125 11.4375 6.53125H12.4688C12.5938 6.53125 12.6875 6.5625 12.7812 6.625C12.9375 6.6875 13.125 6.65625 13.2188 6.5625L13.7812 6C13.9375 5.84375 13.9375 5.5625 13.7188 5.4375C13.4375 5.21875 13.0938 5.125 12.75 5.0625V4.5C12.75 4.25 12.5 4 12.25 4H11.75C11.4688 4 11.25 4.25 11.25 4.5V5.0625C10.2812 5.1875 9.5625 6.03125 9.6875 7.03125C9.78125 7.75 10.3438 8.3125 11.0312 8.53125Z"
                fill="#D80027"
            />
        </svg>
    ),
    menuValue = "",
    subData = null,
    link = "#"
}) => (
    <a
        onClick={closeMenu}
        href={`${link}`}
        className="cursor-pointer hover:bg-slate-50 flex justify-start items-center self-stretch   h-[34px] relative gap-2.5 px-2.5 py-4 rounded bg-white"
    >
        {svg}
        <p className="flex-grow w-[106px] text-sm text-left text-[#7b7b7b]">
            {menuValue}
        </p>
        {subData ? (
            <p className="  text-sm font-bold text-right text-[#373737]">
                {subData}
            </p>
        ) : null}
    </a>
);

function ProfileMenu({ closeMenu }) {
    const menuRef = useRef();

    useEffect(() => {
        menuRef.current.focus();
    }, []);

    const profileDescription = useAuthStore((state) => state.profileDescription);

    const handleLogout = () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("pageRefreshed");
    };

    const revokeToken = async () => {
        const clientId = "P65wI6oAFgp2XGLcyCPr5u3SAMR4Guec4U2aBP23";
        const clientSecret = "uxzebMbeWeO8CIoJ3Uc7HmMGsFG8CMAXM1PamidXPXfF6cgAr9MfZgZgkszZQdW8gq2ZL5LVzSCElLLfrP8Jtl8nx6FTm2Am7rmfDaUGxfFd5slEEqy2QVwFgAcPGb7y";

        const token = localStorage.getItem("authToken");

        const formData = new FormData();
        formData.append("token", token);
        formData.append("client_id", clientId);
        formData.append("client_secret", clientSecret);

        try {
            const response = await fetch(
                "https://eprof-production-6g7zxvibga-uc.a.run.app/o/revoke_token/",
                {
                    method: "POST",
                    body: formData
                }
            );

            if (response.ok) {
                handleLogout();
                Swal.fire({
                    title: "Cerrando sesión",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                }).then(() => {
                    window.location.href = "/login";
                });
            } else {
                console.error("Hubo un problema al revocar el token");
            }
        } catch (error) {
            console.error("Error al intentar revocar el token:", error);
        }
    };


    return (
        <div
            onBlur={closeMenu}
            className="flex flex-col justify-start items-center w-[255px] gap-2.5 py-2.5 rounded bg-white"
            style={{ boxShadow: "0px 8px 15px 0 rgba(0,0,0,0.15)", zIndex:"10", position:"relative" }}
        >
            <div
                ref={menuRef}
                className="flex flex-col justify-start items-start  w-[255px] gap-[5px]"
            >
                <div className="flex justify-start items-start self-stretch  relative gap-2.5 px-2.5">
                    <p className=" text-base font-bold text-left text-[#373737]">
                        Cuenta
                    </p>
                </div>
                <MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    menuValue="Perfil"
                    link="/platform/professionals/profile"
                    svg={
                        <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path
                                d="M14.7812 13.5C13.875 13.5 13.4688 14 12 14C10.5 14 10.0938 13.5 9.1875 13.5C6.875 13.5 5 15.4062 5 17.7188V18.5C5 19.3438 5.65625 20 6.5 20H17.5C18.3125 20 19 19.3438 19 18.5V17.7188C19 15.4062 17.0938 13.5 14.7812 13.5ZM17.5 18.5H6.5V17.7188C6.5 16.2188 7.6875 15 9.1875 15C9.65625 15 10.375 15.5 12 15.5C13.5938 15.5 14.3125 15 14.7812 15C16.2812 15 17.5 16.2188 17.5 17.7188V18.5ZM12 13C14.4688 13 16.5 11 16.5 8.5C16.5 6.03125 14.4688 4 12 4C9.5 4 7.5 6.03125 7.5 8.5C7.5 11 9.5 13 12 13ZM12 5.5C13.625 5.5 15 6.875 15 8.5C15 10.1562 13.625 11.5 12 11.5C10.3438 11.5 9 10.1562 9 8.5C9 6.875 10.3438 5.5 12 5.5Z"
                                fill="#D80027"
                            />
                        </svg>
                    }
                />
                <div className="  w-full flex px-4 py-[5px] ">
                    <div className="relative h-[40px] flex items-center">
                        <input
                            type="checkbox"
                            id="toggler"
                            className="appearance-none cursor-pointer relative bg-neutral-200 w-52 h-[40px] rounded-full before:text-white before:content-['Profesional'] after:content-['Cliente'] before:text-sm/5 before:px-5 before:checked:text-neutral-700 before:transition-all before:duration-500 before:bg-transparent before:absolute before:top-1/2 before:-translate-y-1/2      after:text-neutral-700 after:text-sm/5 after:px-5 after:checked:text-white after:transition-all after:duration-500 after:bg-transparent after:absolute after:top-1/2 after:-translate-y-1/2 after:right-0 before:z-10 after:z-10 peer"
                            checked={profileDescription === "client"}
                        />
                        <label
                            htmlFor="toggler"
                            className="absolute w-[110px] h-[30px] rounded-full bg-[#d80027] left-1 peer-checked:left-[124px] peer-checked:w-20 transition-all duration-500"
                        ></label>
                    </div>
                </div>
                {/* <MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    menuValue="Ver agenda"
                    link="/platform/professional-dashboard"
                    svg={
                        <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path
                                d="M17.5 6H16V4.375C16 4.1875 15.8125 4 15.625 4H14.375C14.1562 4 14 4.1875 14 4.375V6H10V4.375C10 4.1875 9.8125 4 9.625 4H8.375C8.15625 4 8 4.1875 8 4.375V6H6.5C5.65625 6 5 6.6875 5 7.5V18.5C5 19.3438 5.65625 20 6.5 20H17.5C18.3125 20 19 19.3438 19 18.5V7.5C19 6.6875 18.3125 6 17.5 6ZM17.3125 18.5H6.6875C6.5625 18.5 6.5 18.4375 6.5 18.3125V9H17.5V18.3125C17.5 18.4375 17.4062 18.5 17.3125 18.5Z"
                                fill="#D80027"
                            />
                        </svg>
                    }
                />
                {/* link="/platform/analytics"*/}
               {/* <MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    link="/platform/404"
                    menuValue="Analitica de la cuenta"
                    svg={
                        <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path
                                d="M16 14H14C13.4375 14 13 14.4688 13 15V19C13 19.5625 13.4375 20 14 20H16C16.5312 20 17 19.5625 17 19V15C17 14.4688 16.5312 14 16 14ZM15.5 18.5H14.5V15.5H15.5V18.5ZM21 10H19C18.4375 10 18 10.4688 18 11V19C18 19.5625 18.4375 20 19 20H21C21.5312 20 22 19.5625 22 19V11C22 10.4688 21.5312 10 21 10ZM20.5 18.5H19.5V11.5H20.5V18.5ZM11 10H9C8.4375 10 8 10.4688 8 11V19C8 19.5625 8.4375 20 9 20H11C11.5312 20 12 19.5625 12 19V11C12 10.4688 11.5312 10 11 10ZM10.5 18.5H9.5V11.5H10.5V18.5ZM6 15H4C3.4375 15 3 15.4688 3 16V19C3 19.5625 3.4375 20 4 20H6C6.53125 20 7 19.5625 7 19V16C7 15.4688 6.53125 15 6 15ZM5.5 18.5H4.5V16.5H5.5V18.5ZM5 12C5.8125 12 6.5 11.3438 6.5 10.5C6.5 10.375 6.46875 10.25 6.4375 10.125L9.59375 6.96875C9.71875 7 9.84375 7 10 7C10.1875 7 10.3438 6.96875 10.5312 6.90625L13.5 9.28125C13.5 9.375 13.5 9.4375 13.5 9.5C13.5 10.3438 14.1562 11 15 11C15.8125 11 16.5 10.3438 16.5 9.5C16.5 9.4375 16.4688 9.375 16.4688 9.28125L19.4375 6.90625C19.625 6.96875 19.7812 7 20 7C20.8125 7 21.5 6.34375 21.5 5.5C21.5 4.6875 20.8125 4 20 4C19.1562 4 18.5 4.6875 18.5 5.5C18.5 5.59375 18.5 5.65625 18.5 5.75L15.5312 8.125C15.3438 8.0625 15.1875 8 14.9688 8C14.7812 8 14.625 8.0625 14.4375 8.125L11.4688 5.75C11.4688 5.65625 11.5 5.59375 11.5 5.5C11.5 4.6875 10.8125 4 10 4C9.15625 4 8.5 4.6875 8.5 5.5C8.5 5.65625 8.5 5.78125 8.53125 5.90625L5.375 9.0625C5.25 9.03125 5.125 9 5 9C4.15625 9 3.5 9.6875 3.5 10.5C3.5 11.3438 4.15625 12 5 12Z"
                                fill="#D80027"
                            />
                        </svg>
                    }
                />*/}
            </div>
            <MenuItem
                onClick={closeMenu}
                closeMenu={closeMenu}
                menuValue=" Ajustes"
                link="/platform/settings/profile"
                svg={
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M14.1249 7.40625L15.1249 6.84375C15.4062 6.6875 15.5624 6.34375 15.4687 6C15.1249 4.6875 14.4062 3.5 13.4687 2.53125C13.2187 2.3125 12.8437 2.25 12.5624 2.40625L11.5624 3C11.2499 2.75 10.9062 2.5625 10.5312 2.40625V1.25C10.5312 0.90625 10.3124 0.625 9.96866 0.53125C8.68741 0.1875 7.28116 0.1875 5.99991 0.53125C5.65616 0.625 5.43741 0.90625 5.43741 1.25V2.40625C5.06241 2.5625 4.71866 2.75 4.40616 3L3.40616 2.40625C3.12491 2.25 2.74991 2.3125 2.49991 2.53125C1.56241 3.5 0.843661 4.6875 0.499911 6C0.406161 6.34375 0.562411 6.6875 0.843661 6.84375L1.84366 7.40625C1.81241 7.625 1.81241 7.8125 1.81241 8.03125C1.81241 8.21875 1.81241 8.40625 1.84366 8.59375L0.843661 9.1875C0.562411 9.34375 0.406161 9.6875 0.499911 10.0312C0.843661 11.3438 1.56241 12.5312 2.49991 13.5C2.74991 13.7188 3.12491 13.7812 3.40616 13.625L4.40616 13.0312C4.71866 13.2812 5.06241 13.4688 5.43741 13.625V14.7812C5.43741 15.125 5.65616 15.4062 5.99991 15.5C7.28116 15.8438 8.68741 15.8438 9.96866 15.5C10.3124 15.4062 10.5312 15.125 10.5312 14.7812V13.625C10.9062 13.4688 11.2499 13.2812 11.5624 13.0312L12.5624 13.625C12.8437 13.7812 13.2187 13.7188 13.4687 13.5C14.4062 12.5312 15.1249 11.3438 15.4687 10.0312C15.5624 9.6875 15.4062 9.34375 15.1249 9.1875L14.1249 8.59375C14.1562 8.21875 14.1562 7.8125 14.1249 7.40625ZM12.4687 9.40625L13.8437 10.1875C13.5937 10.8438 13.2499 11.4688 12.7812 12L11.4062 11.2188C10.4062 12.0625 10.2812 12.1562 9.03116 12.5938V14.1875C8.68741 14.25 8.34366 14.2812 7.96866 14.2812C7.62491 14.2812 7.28116 14.25 6.93741 14.1875V12.5938C5.68741 12.1562 5.53116 12.0625 4.56241 11.2188L3.18741 12C2.71866 11.4688 2.37491 10.8438 2.12491 10.1875L3.49991 9.40625C3.24991 8.09375 3.24991 7.9375 3.49991 6.625L2.12491 5.84375C2.37491 5.1875 2.71866 4.5625 3.18741 4.03125L4.56241 4.8125C5.56241 3.96875 5.68741 3.875 6.93741 3.4375V1.84375C7.28116 1.78125 7.62491 1.75 7.99991 1.75C8.34366 1.75 8.68741 1.78125 9.03116 1.84375V3.4375C10.2812 3.875 10.4374 3.96875 11.4062 4.8125L12.7812 4.03125C13.2499 4.5625 13.5937 5.1875 13.8437 5.84375L12.4687 6.625C12.7187 7.9375 12.7187 8.09375 12.4687 9.40625ZM7.99991 5C6.34366 5 4.99991 6.375 4.99991 8C4.99991 9.65625 6.34366 11 7.99991 11C9.62491 11 10.9999 9.65625 10.9999 8C10.9999 6.375 9.62491 5 7.99991 5ZM7.99991 9.5C7.15616 9.5 6.49991 8.84375 6.49991 8C6.49991 7.1875 7.15616 6.5 7.99991 6.5C8.81241 6.5 9.49991 7.1875 9.49991 8C9.49991 8.84375 8.81241 9.5 7.99991 9.5Z"
                            fill="#D80027"
                        />
                    </svg>
                }
            />
            <div className="flex flex-col justify-start items-start  w-[255px] gap-[5px]">
                <div className="flex justify-start items-start self-stretch  relative gap-2.5 px-2.5">
                  {/* <p className=" text-base font-bold text-left text-[#373737]">
                        Finanzas
                    </p>*/}
                </div>
                {/*link="/platform/funds"*/}
                {/* <MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    menuValue="Saldo"
                    subData="$0,00 USD"
                    link="/platform/404"
                />
                {/*link="/platform/funds"*/}
                {/* <MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    menuValue="Agregar fondos"
                    link="/platform/404"
                    svg={<img src={dollar} alt="dollar" />}
                />
                {/*link="/platform/withdraw"*/}
                 {/*<MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    link="/platform/404"
                    menuValue="Retirar fondos"
                    svg={
                        <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path
                                d="M15.75 13H8.25C8.09375 13 8 13.125 8 13.25V14.25C8 14.4063 8.09375 14.5 8.25 14.5H15.75C15.875 14.5 16 14.4063 16 14.25V13.25C16 13.125 15.875 13 15.75 13ZM17.5 4.18755L16.1562 5.1563L14.9375 4.31255C14.4062 3.93755 13.7188 3.93755 13.1875 4.31255L12 5.1563L10.7812 4.31255C10.5312 4.12505 10.2188 4.0313 9.90625 4.0313C9.5625 4.0313 9.28125 4.12505 9.03125 4.31255L7.8125 5.1563L6.46875 4.18755C5.84375 3.75005 5 4.18755 5 4.93755V19.0938C5 19.8125 5.84375 20.2813 6.46875 19.8438L7.8125 18.8438L9.03125 19.7188C9.5625 20.0938 10.25 20.0938 10.7812 19.7188L12 18.8438L13.1875 19.7188C13.7188 20.0938 14.4062 20.0938 14.9375 19.7188L16.1562 18.8438L17.5 19.8438C18.125 20.2813 19 19.8438 19 19.0938V4.93755C19 4.18755 18.125 3.75005 17.5 4.18755ZM17.5 17.9688L16.1562 17L14.0625 18.5L11.9688 17L9.90625 18.5L7.8125 17L6.5 17.9688V6.06255L7.8125 7.0313L9.90625 5.5313L12 7.0313L14.0625 5.5313L16.1562 7.0313L17.5 6.06255V17.9688ZM15.75 9.50005H8.25C8.09375 9.50005 8 9.62505 8 9.75005V10.75C8 10.9063 8.09375 11 8.25 11H15.75C15.875 11 16 10.9063 16 10.75V9.75005C16 9.62505 15.875 9.50005 15.75 9.50005Z"
                                fill="#D80027"
                            />
                        </svg>
                    }
                />
                {/*link="/platform/quote"*/}
                 {/*<MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    link="/platform/404"
                    menuValue="Crear cotización"
                    svg={
                        <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path
                                d="M15.25 16.5H12.75C12.5938 16.5 12.5 16.625 12.5 16.75V17.25C12.5 17.4062 12.5938 17.5 12.75 17.5H15.25C15.375 17.5 15.5 17.4062 15.5 17.25V16.75C15.5 16.625 15.375 16.5 15.25 16.5ZM8.5 11.5V14.5C8.5 14.7812 8.71875 15 9 15H15C15.25 15 15.5 14.7812 15.5 14.5V11.5C15.5 11.25 15.25 11 15 11H9C8.71875 11 8.5 11.25 8.5 11.5ZM9.5 12H14.5V14H9.5V12ZM17.5312 7.0625L14.9062 4.46875C14.625 4.1875 14.25 4 13.875 4H7.46875C6.65625 4.03125 6 4.6875 6 5.53125V18.5312C6 19.3438 6.65625 20 7.46875 20H16.4688C17.3125 20 18 19.3438 18 18.5312V8.125C18 7.75 17.8125 7.34375 17.5312 7.0625ZM13.9688 5.625L16.375 8.03125H13.9688V5.625ZM16.5 18.5312H7.46875V5.53125H12.4688V8.78125C12.4688 9.1875 12.8125 9.53125 13.2188 9.53125H16.5V18.5312ZM8.75 7.5H11.25C11.375 7.5 11.5 7.40625 11.5 7.25V6.75C11.5 6.625 11.375 6.5 11.25 6.5H8.75C8.59375 6.5 8.5 6.625 8.5 6.75V7.25C8.5 7.40625 8.59375 7.5 8.75 7.5ZM8.75 9.5H11.25C11.375 9.5 11.5 9.40625 11.5 9.25V8.75C11.5 8.625 11.375 8.5 11.25 8.5H8.75C8.59375 8.5 8.5 8.625 8.5 8.75V9.25C8.5 9.40625 8.59375 9.5 8.75 9.5Z"
                                fill="#D80027"
                            />
                        </svg>
                    }
                />
            </div>
            <div className="flex flex-col justify-start items-start self-stretch   gap-[5px]">
                <MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    link="/platform/invite-friend"
                    menuValue="Invitar amigos"
                    svg={<img src={friends} alt="friends" />}
                />

                <MenuItem
                    onClick={() => {
                        window.open(
                            "https://api.whatsapp.com/send?phone=50251119923"
                        );
                        closeMenu();
                    }}
                    closeMenu={closeMenu}
                    menuValue="Soporte"
                    svg={
                        <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path
                                d="M15 15H14.8438C14.4688 15 14.0938 15.0938 13.7188 15.2188C13.1875 15.4062 12.5938 15.5 12 15.5C11.375 15.5 10.7812 15.4062 10.25 15.2188C9.875 15.0938 9.5 15.0312 9.125 15.0312H9C6.78125 15.0312 5 16.8125 5 19C5 19.5625 5.4375 20 6 20H18C18.5312 20 19 19.5625 19 19C19 16.8125 17.1875 15 15 15ZM6.53125 18.5C6.78125 17.375 7.78125 16.5312 9 16.5H9.125C9.28125 16.5 9.5 16.5625 9.75 16.6562C10.4688 16.875 11.2188 17 11.9688 17C12.75 17 13.5 16.875 14.2188 16.6562C14.4688 16.5625 14.6875 16.5 14.8438 16.5H15C16.1875 16.5312 17.1875 17.375 17.4375 18.5H6.53125ZM6.71875 11C7.125 11 7.4375 10.6875 7.4375 10.2812V10C7.4375 7.5 9.46875 5.46875 12 5.46875C14.5 5.46875 16.5312 7.5 16.5312 10V10.4062C16.5312 11.5938 15.5625 12.5625 14.375 12.5625H13.6562C13.5312 12 13.0312 11.5938 12.4688 11.5938H11.5C10.8125 11.5938 10.2812 12.125 10.2812 12.8125C10.2812 13.4688 10.8125 14.0312 11.5 14.0312C11.5 14.0312 11.5 14.0312 11.5 14H14.375C16.375 14 17.9688 12.4062 18 10.4062V10C18 6.71875 15.2812 4 12 4C8.6875 4 6 6.71875 6 10V10.2812C6 10.6875 6.3125 11 6.71875 11ZM12 8C13.0938 8.03125 13.9688 8.90625 14 10C13.9688 10.375 13.875 10.7188 13.7188 11C13.9375 11.1562 14.125 11.3438 14.2812 11.5625H14.375C14.7812 11.5625 15.125 11.3438 15.3125 11.0312C15.4062 10.7188 15.5 10.375 15.5 10C15.5 8.09375 13.9062 6.5 12 6.5C10.0625 6.5 8.5 8.09375 8.5 10C8.5 10.9062 8.8125 11.6875 9.375 12.3125C9.5 11.7812 9.8125 11.3125 10.25 11C10.0938 10.7188 10 10.375 10 10C10 8.90625 10.875 8.03125 12 8Z"
                                fill="#D80027"
                            />
                        </svg>
                    }
                />*/}
                <div className="flex flex-col justify-start items-start  w-[255px] gap-[5px]">
                <div className="flex justify-start items-start self-stretch  relative gap-2.5 px-2.5">
                    <p className=" text-base font-bold text-left text-[#373737]">
                        Otros
                    </p>
                </div>
                {/*link="/platform/funds"
                {/*<MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    menuValue="Ver trabajos"
                    link="/platform/jobs"
                    svg={
                        <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path
                                d="M17.5 6H16V4.375C16 4.1875 15.8125 4 15.625 4H14.375C14.1562 4 14 4.1875 14 4.375V6H10V4.375C10 4.1875 9.8125 4 9.625 4H8.375C8.15625 4 8 4.1875 8 4.375V6H6.5C5.65625 6 5 6.6875 5 7.5V18.5C5 19.3438 5.65625 20 6.5 20H17.5C18.3125 20 19 19.3438 19 18.5V7.5C19 6.6875 18.3125 6 17.5 6ZM17.3125 18.5H6.6875C6.5625 18.5 6.5 18.4375 6.5 18.3125V9H17.5V18.3125C17.5 18.4375 17.4062 18.5 17.3125 18.5Z"
                                fill="#D80027"
                            />
                        </svg>
                    }
                />*/}
                {/*link="/platform/withdraw"*/}
                <MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    link="/platform/404"
                    menuValue="Certificaciones"
                    svg={
                        <svg
                        width={20}
                        height={20}
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="  w-[20px] h-[20px] relative"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <path
                          d="M24.4144 8.82813L21.1331 5.58594C20.7816 5.23438 20.3128 5 19.8441 5H11.8363C10.8206 5.03906 10.0003 5.85938 10.0003 6.91406V10H11.8363V6.91406H18.0863V10.9766C18.0863 11.4844 18.5159 11.9141 19.0238 11.9141H23.1253V23.1641H13.7503V25H23.0863C24.1409 25 25.0003 24.1797 25.0003 23.1641V10.1563C25.0003 9.6875 24.7659 9.17969 24.4144 8.82813ZM19.9613 10.0391V7.03125L22.9691 10.0391H19.9613ZM14.6488 18.2422C14.9222 17.9297 15.0394 17.5 14.9613 17.1094C14.7269 16.2891 14.7269 16.4063 14.9613 15.625C15.0394 15.1953 14.9222 14.7656 14.6488 14.4922C14.0628 13.9063 14.1019 13.9844 13.9066 13.2031C13.7894 12.7734 13.4769 12.4609 13.0863 12.3438C12.305 12.1484 12.4222 12.1875 11.8363 11.6016C11.5238 11.3281 11.0941 11.2109 10.7034 11.3281C9.9222 11.5234 10.0394 11.5234 9.25813 11.3281C8.86751 11.2109 8.43782 11.3281 8.12532 11.6016C7.53938 12.1875 7.65657 12.1484 6.87532 12.3438C6.4847 12.4609 6.1722 12.7734 6.05501 13.2031C5.82063 13.9844 5.89876 13.9063 5.31282 14.4922C5.03938 14.7656 4.9222 15.1953 5.00032 15.625C5.2347 16.4063 5.2347 16.2891 5.00032 17.1094C4.9222 17.5 5.03938 17.9297 5.31282 18.2422C5.89876 18.8281 5.82063 18.7109 6.05501 19.5313C6.1722 19.9219 6.4847 20.2344 6.87532 20.3516C7.4222 20.5078 7.30501 20.4688 7.46126 20.5469V25L9.96126 23.75L12.4613 25V20.5469C12.6566 20.4688 12.5394 20.5078 13.0863 20.3516C13.4769 20.2344 13.7894 19.9219 13.9066 19.5313C14.1409 18.7109 14.0628 18.8281 14.6488 18.2422ZM10.0003 18.75C8.59407 18.75 7.50032 17.6563 7.50032 16.25C7.50032 14.8828 8.59407 13.75 10.0003 13.75C11.3675 13.75 12.5003 14.8828 12.5003 16.25C12.5003 17.6563 11.3675 18.75 10.0003 18.75Z"
                          fill="#D80027"
                        />
                      </svg>
                    }
                />
                <MenuItem
                    onClick={closeMenu}
                    closeMenu={closeMenu}
                    link="/platform/professionals-directory"
                    menuValue="Profesionales"
                    svg={
                        <svg
              width={20}
              height={20}
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="  w-[20px] h-[20px] relative"
              preserveAspectRatio="xMidYMid meet"
            >
              <path
                d="M15 16.2499C18.0859 16.2499 20.625 13.7499 20.625 10.6249C20.625 7.53894 18.0859 4.99988 15 4.99988C11.875 4.99988 9.375 7.53894 9.375 10.6249C9.375 13.7499 11.875 16.2499 15 16.2499ZM15 6.87488C17.0313 6.87488 18.75 8.59363 18.75 10.6249C18.75 12.6952 17.0313 14.3749 15 14.3749C12.9297 14.3749 11.25 12.6952 11.25 10.6249C11.25 8.59363 12.9297 6.87488 15 6.87488ZM18.5547 16.9139L16.3672 22.9296L15.625 19.6874L16.875 17.4999H13.125L14.375 19.6874L13.5938 22.9296L11.4063 16.9139C8.51563 16.953 6.25 19.2577 6.25 22.1483V23.1249C6.25 24.1796 7.07031 24.9999 8.125 24.9999H21.875C22.8906 24.9999 23.75 24.1796 23.75 23.1249V22.1483C23.75 19.2577 21.4453 16.953 18.5547 16.9139ZM10 23.1249H8.125V22.1483C8.125 20.7421 8.94531 19.5702 10.1953 19.0233L11.6797 23.1249H10ZM21.875 23.1249H18.2813L19.8047 19.0233C21.0156 19.5702 21.875 20.7421 21.875 22.1483V23.1249Z"
                fill="#D80027"
              />
            </svg>
                    }
                />
            </div>

                <button
                    className="flex-grow  text-sm text-left text-[#7b7b7b] cursor-pointer hover:bg-slate-50 flex justify-start items-center self-stretch   h-[34px] relative gap-2.5 px-2.5 py-4 rounded bg-white" // Reemplaza "clase-del-menu-item" por la clase correspondiente del MenuItem
                    onClick={async () => {
                        await revokeToken();
                    }}
                >
                    <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            d="M7 6C5.34375 6 4 7.34375 4 9V15C4 16.6562 5.34375 18 7 18H9.625C9.8125 18 10 17.8438 10 17.625V16.875C10 16.6875 9.8125 16.5 9.625 16.5H7C6.15625 16.5 5.5 15.8438 5.5 15V9C5.5 8.1875 6.15625 7.5 7 7.5H9.625C9.8125 7.5 10 7.34375 10 7.125V6.375C10 6.1875 9.8125 6 9.625 6H7ZM14.2188 6.625L13.5938 7.25C13.4375 7.375 13.4375 7.625 13.5938 7.78125L17.125 11.1875H9.375C9.15625 11.1875 9 11.375 9 11.5625V12.4375C9 12.6562 9.15625 12.8125 9.375 12.8125H17.125L13.5938 16.25C13.4375 16.4062 13.4375 16.6562 13.5938 16.7812L14.2188 17.4062C14.3438 17.5625 14.5938 17.5625 14.75 17.4062L19.875 12.2812C20.0312 12.125 20.0312 11.9062 19.875 11.75L14.75 6.625C14.5938 6.46875 14.3438 6.46875 14.2188 6.625Z"
                            fill="#D80027"
                        />
                    </svg>
                    Cerrar sesión
                </button>
            </div>
        </div>
    );
}

export default ProfileMenu;
